const STORAGE_KEY = "bookdental:productTourSeen";

/** Preferência de UI puramente local (nunca banco) — mesmo padrão de layout-style.ts/producao. */
export function hasSeenTour(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function markTourSeen() {
  try {
    localStorage.setItem(STORAGE_KEY, "1");
  } catch {
    // localStorage indisponível (modo privado etc.) — sem persistência, sem problema
  }
}
